import './Press.css'

function Press() {
    return <section className='press'>
        <h4>Är du Journalist eller har någon press relaterad fråga?</h4>
        <p>Kontakta Jessica Eliasson på <a href='mailto:media@capapult.se' target='blank'>media@capapult.se</a></p>
    </section>
}

export default Press